import { Component, EventEmitter, Injector, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { trackByIndex } from '@shared/common/track-by.util';
import { MonitoringService } from '@app/shared/common/telemetry-implementation/MonitoringService ';
import { AvatarCollectionService } from '@shared/common/avatarView/avatar-collection.services';
import { AbpSessionService } from 'abp-ng2-module';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { WarningModalComponent } from '../../shared/warning-modal/warning-modal.component';

@Component({
  standalone: false,
  selector: 'app-client-image-model',
  templateUrl: './client-image-model.component.html',
  styleUrls: ['./client-image-model.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ClientImageModelComponent implements OnInit {
    readonly trackByIndex = trackByIndex;

  @Output() valueChange = new EventEmitter();
    @ViewChild('clientimgmodal', { static: true }) modal: ModalDirective;
    @ViewChild("SignModalPopup", { static: true }) SignModalPopup: WarningModalComponent;
  fileExtension: string;
  selectedAvatarIndex: number;    
  imagePathModal = '';
  imagePath = '';
  showImg = true;
  isImage = true;
  tabIndex = 1;
  photoImage = [{ 'id': 1, 'icon': '' }];
  allowedPhotoFile = ["png", "jpg", "jpeg"];
  tempDataForReminderModal = [
      { compName: '', img: '' },
  ];
  showImgModal = false;
  dateTime = new Date();
  msg:string;
  constructor(injector: Injector,
      private _avatarCollectionService: AvatarCollectionService,
      private _monitorService:MonitoringService,
      private _abpSessionService: AbpSessionService
      ) {
  }
  cancelPhoto() {
    this._monitorService.logEvent("cancelPhoto",{"cancelPhoto":"cancelPhoto"+this.msg+this.dateTime});

      this.showImg = false;
      this.imagePathModal = '';
      this.selectedAvatarIndex = -1;
  }
  selectIcon(c: string, index: number) {
    this._monitorService.logEvent("selectIcon",{"SelectIcon":"icon"+this.msg+this.dateTime});

      this.selectedAvatarIndex = index;
      this.imagePathModal = c;
      this.showImg = true;
  }
  onKey(index: number) {
      this.tabIndex = index;
  }
  show(): void {
      this.modal.show();
  }
  close() {
      this.modal.hide();
  }
  deletePicture() {
      this.selectedAvatarIndex = -1;
      this.imagePath = '';
      this.imagePathModal = '';
      this.tempDataForReminderModal[0].img = this.imagePath;
  }
  onShown(): void {
  }
  ngOnInit(): void {
      this.photoImage = this._avatarCollectionService.getAllAvatars();
      this.msg="userId = "+this._abpSessionService.userId +"tenantId ="+this._abpSessionService.tenantId;
  }
  public getfileContent(fileList: FileList) {
    this._monitorService.logEvent("getfileContent",{"getfileContent":"fileContent"+this.msg+this.dateTime});

          const fileUpload = document.getElementById('UploadFile') as HTMLInputElement;
          let FileName = fileList[0].name;
          this.isImage=false;
          this.fileExtension = FileName.replace(/^.*\./, '');
          if (!this.allowedPhotoFile.includes(this.fileExtension.toLocaleLowerCase())) {
              //show error
              this.SignModalPopup.show();
              return;
          }
          for (let index = 0; index < fileUpload.files.length; index++) {
              let reader = new FileReader();
              reader.onload = (e: any) => {
                  this.imagePathModal = e.target.result;
              };
              reader.readAsDataURL(fileUpload.files[index]);
          }
          this.showImg = true;
          this.showImgModal = true;
          this.imagePathModal = this.imagePathModal;
  }
  savePhoto() {
    this._monitorService.logEvent("SavePhoto",{"SavePhoto":"inImagepathModel"+this.msg+this.dateTime});
      this.imagePathModal = this.imagePathModal;
      this.valueChange.emit(this.imagePathModal);
      this.imagePathModal = '';
      this.isImage=true;
      this.showImgModal = false;
      this.modal.hide();
  }
  saveCancel() {
      this.modal.hide();
      this.showImgModal = false;
      this.imagePathModal = '';
  }
  removeImage() {
    this._monitorService.logEvent("removeImage",{"RemoveImage":"image remove"+this.msg+this.dateTime});
      this.isImage=true;
      this.showImgModal = false;
      this.deletePicture();
  }

}
